import React from "react";
import mainImg from "../images/main-img.svg";
import Button from "./Button";

import { faStripe, faLyft, faSpotify, faPiedPiper } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Hero() {

  return (
    <>
      <main className="mx-auto mt-10 px-6 pb-12">
        <div className="text-center w-4/5 sm:w-2/3 mx-auto py-4" data-aos="fade-in">
          <h2 className="text-3xl leading-tight font-extrabold text-gray-900 xs:text-4xl sm:text-5xl md:text-6xl">
            Your headline goes here
          </h2>
          <p className="mt-6 text-base font-body text-gray-700 sm:text-lg md:text-xl">
            Supplement it with an easy to read subheading.
          </p>
          <div className="mt-5 sm:mt-8 sm:flex sm:justify-center">
            <Button
              btnText="Get started"
              color="dark"
            />
          </div>
        </div>
        <div className="hero-image container mx-auto mt-6 lg:mt-12 relative" data-aos="fade-up">          
          <img height="500" width="1000" className="w-full z-20 object-contain mx-auto md:max-w-xl lg:max-w-4xl relative" src={mainImg} alt="main-img" />
        </div>
        <ul className="flex justify-center items-center mt-6 lg:mt-12 list-none">
          <li className="p-4">
            <FontAwesomeIcon className="w-10 text-gray-600" icon={faStripe} size="3x" />
          </li>
          <li className="p-4">
            <FontAwesomeIcon className="w-10 text-gray-600" icon={faLyft} size="3x" />
          </li>
          <li className="p-4">
            <FontAwesomeIcon className="w-10 text-gray-600" icon={faSpotify} size="3x" />
          </li>
          <li className="p-4">
            <FontAwesomeIcon className="w-10 text-gray-600" icon={faPiedPiper} size="3x" />
          </li>
        </ul>
      </main>
    </>
  );
}

export default Hero;